import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Hidden from '@material-ui/core/Hidden';
import Container from '@material-ui/core/Container';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import Toolbar from 'components/Layout/Toolbar';
import TableWrapper from 'components/Shared/TableWrapper';
import { WithStyles } from 'decorators/withStyles';
import { IPaginationParams } from 'interfaces/pagination';
import { IUser } from 'interfaces/user';
import React, { Fragment } from 'react';
import { of } from 'rxjs';
import RxOp from 'rxjs-operators';
import reportService from 'services/report';
import userService from 'services/user';

import ListItem from './ListItem';

interface IState extends IStateList<IUser> {
  current?: IUser;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
}))
export default class UserListPage extends ListComponent<IProps, IState> {
  constructor(props: {}) {
    super(props, 'fullName');
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });

    userService.list(this.mergeParams(params)).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this)
    ).subscribe(items => {
      this.setPaginatedData(items);
    }, error => this.setError(error));
  }

  onClickRefresh = () => this.loadData();

  exportReport = () => {
    this.setState({ loading: true });
    reportService.exportReportAccessXLS().pipe(
      RxOp.logError(), RxOp.bindComponent(this), RxOp.catchError(err => of({})),
    ).subscribe(data => {
      if (data.reportURL) window.open(data.reportURL, '_blank');
      this.setState({ loading: false });
    }, err => this.setError(err));
  }

  render() {
    const { items, loading } = this.state;

    return (
      <Fragment>
        <Toolbar title='Relatório de Acesso' breadcrumbs={[{ title: 'Relatórios' }, { title: 'Acesso' }]} />
        <Container>
          <Card>
            {this.renderLoader()}
            <CardContent>
              <Grid container alignItems="center" justify='space-between'>
                <Grid item xs sm={6} lg={4}>
                  {this.renderSearch()}
                </Grid>
                <Grid item xs='auto'>
                  <Button
                    color="primary"
                    variant='contained'
                    size="large"
                    disabled={loading}
                    aria-controls='exportar-relatorio'
                    aria-haspopup='false'
                    onClick={this.exportReport}
                  >
                    Exportar <Hidden xsDown> relatório</Hidden>
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <TableWrapper minWidth={1000}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCellSortable {...this.sortableProps} column='fullName'>
                            Nome
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='email'>
                            Email
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='roles'>
                            Perfil
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='roles'>
                            Último Acesso
                          </TableCellSortable>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.renderEmptyAndErrorMessages(5)}
                        {items.map(user =>
                          <ListItem
                            key={user.id}
                            user={user}
                          />
                        )}
                      </TableBody>
                    </Table>
                  </TableWrapper>
                  {this.renderTablePagination()}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}